import { Component, Input } from '@angular/core';
import { ProdutoFoto } from '../../../core/models/produtos/produto-foto';
import { ProdutoPromocional } from '../../../core/models/produtos/produto-promocional';

@Component({
  selector: 'app-pedido-itens-modal-fotos',
  templateUrl: './pedido-itens-modal-fotos.component.html',
  styleUrls: ['./pedido-itens-modal-fotos.component.scss'],
  standalone: false
})
export class PedidoItensModalFotosComponent {
  @Input() fotos: ProdutoFoto[] = [];
  @Input() produtoSelecionado: ProdutoPromocional = null;
}
